import { useState, useEffect, ChangeEvent, FormEvent } from 'react';
import { Button, Col, Form, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { useNotification } from '../../../hooks/useNotification';
import { Tooltip } from 'react-tooltip';
import { BsTrello } from "react-icons/bs";
import IBoard, { IBoardBadge, IBoardLists, SettingsData } from '../../../interfaces/ISettings';
import { useApi } from '../../../Context/ApiContext.tsx';

import useApiRequests from '../../../hooks/useApiRequests';
import Title from '../../Text/Title/Title';
import './settings.css';
import useChangeTextById from '../../../hooks/useChangeTextById.tsx';


export default function Settings() {
    const { notify } = useNotification();
    const { getSettings, saveSettings, getAllBoards, getDashboardBadges, getDashboardLists, getApiTokenLink, getUserRoleInBoard, getMenuData } = useApiRequests();
    const { setMenuData } = useApi();

    const [boards, setBoards] = useState<IBoard[] | null>(null);
    const [boardBadges, setBoardBadges] = useState<IBoardBadge[] | null>(null);
    const [boardLists, setBoardLists] = useState<IBoardLists[] | null>(null);
    const [selectedTab, setSelectedTab] = useState("1");
    const [showAllTabs, setShowAllTabs] = useState(false);
    const [buttonText, setButtonText] = useState("Salvar");

    //Para usar o hook basta colocar o state como o buttonText
    useChangeTextById('btn-settings-save', buttonText);
    
    const [settings, setSettings] = useState<SettingsData>({
        id: null,
        email: '',
        kanban: {
            backlog: '',
            todo: '',
            doing: '',
            testing: '',
            errorFix: '',
            done: '',
            reproved: '',
          },
          complexity: {
            easy: '',
            midLevel: '',
            complex: '',
            veryComplex: '',
          },
          boardId: '',
          userRoleInSelectedBoard: '',
          userId: '',
          apiToken: '',
    });
  

    useEffect(() => {
        const fetchData = async () => {
            const data = await getSettings();
            setSettings(data.data);
            if (data.data.apiToken != null) {
                GetAllBoards();
                setShowAllTabs(true);
            }

            if (data.msg != null && data.msg != "") {
                notify(data.msg, { type: "alert" });
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (settings.boardId != null && settings.boardId != "") {
            getDashboardBoardChange(settings.boardId);
        }
    }, [settings.boardId]);

    async function GetAllBoards() {
        const data = await getAllBoards();
        if (data.success && data.data != null) {
            setBoards(JSON.parse(data.data));
        }else{

            if(data.msg?.indexOf("401") !== -1)
            notify("Token de usuário não é válido ou expirou!", { type: "error" });
        }
    }



    async function SaveSettings(e?: FormEvent) {
        e?.preventDefault();
        try{
            setButtonText("Salvando");
            const data = await saveSettings(settings);
            if (data.success && data.data != null) {
                setSettings(data.data);
                setShowAllTabs(true);
                GetAllBoards();
                notify("Configurações Salvas com sucesso!", { type: "success" });
            }
        } finally{
            setButtonText("Salvar");
        }
    }

    const handleApiTokenChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSettings({ ...settings, apiToken: e.target.value });
    };

    const getDashboardBoardChange = async (id: string) => {
        const data = await getUserRoleInBoard(settings);
        setSettings(data.data);
        
        if(data.data.userRoleInSelectedBoard == "admin"){
            const badges = await getDashboardBadges(id);
            if (badges.data != null) {
                setBoardBadges(badges.data);
            }
    
            const lists = await getDashboardLists(id);
            if (lists.data != null) {
                setBoardLists(lists.data);
            }
        }
        const menuData = await getMenuData();
        if(menuData.success){
            setMenuData(menuData.data.menu);
            // console.log(menuData.data)
            localStorage.removeItem("menu");
            localStorage.setItem("menu", JSON.stringify(menuData.data.menu));
        }
    };

    const handleDashboardBoardChange = async (e: ChangeEvent<HTMLInputElement>) => {
        setSettings({ ...settings, boardId: e.target.value });
    };

    const handleVerifyToken = async (e: ChangeEvent<HTMLInputElement>) => {
        const token = e.target.value;
        if(token !== null && token.length >= 76){
            const data = await saveSettings(settings);
            if (data.success && data.data != null) {
                setSettings(data.data);
                setShowAllTabs(true);
                GetAllBoards();
            }
        }
    };

    const authenticationSuccess = async () => {
        const token = Trello.token();
        let settingsOld = settings;
        settingsOld.apiToken = token;
        const data = await saveSettings(settingsOld);
        if (data.success && data.data != null) {
            setSettings(data.data);
            setShowAllTabs(true);
            GetAllBoards();
            notify("Configurações Salvas com sucesso!", { type: "success" });
        }
    };
      
    const authenticationFailure = function() {
        notify("Erro ao realizar a autenticação!", { type: "error" });
    };

    const PopUpTrelloAuthorize = function(){
        window.Trello.authorize({
            type: 'popup',
            name: 'Getting Started Application',
            scope: {
              read: 'true',
              write: 'true' },
            expiration: 'never',
            success: authenticationSuccess,
            error: authenticationFailure
          });
    }

    return (
        <div className='page-container'>
            <div className='d-flex flex-wrap justify-content-between'>
                <Title>Configurações</Title>
                <Button
                    color="primary"
                    id="btn-settings-save"
                    onClick={SaveSettings}
                    style={{
                        width: "100px",
                        height: "40px"
                    }}
                >
                    Salvar
                </Button>
            </div>
            <Nav tabs className='mt-5'>
                <NavItem>
                    <NavLink
                        className={selectedTab == "1" ? "active" : ""}
                        onClick={() => setSelectedTab("1")}
                    >
                        Quadros
                    </NavLink>
                </NavItem>
                {showAllTabs == true && settings.userRoleInSelectedBoard == "admin" &&
                    <>
                        <NavItem>
                            <NavLink
                                className={selectedTab == "2" ? "active" : ""}
                                onClick={() => setSelectedTab("2")}
                            >
                                Kanban
                            </NavLink>
                        </NavItem>
                        <NavItem >
                            <NavLink
                                className={selectedTab == "3" ? "active" : ""}
                                onClick={() => setSelectedTab("3")}
                            >
                                Complexidade
                            </NavLink>
                        </NavItem>
                    </>
                }
            </Nav>
            <TabContent activeTab={selectedTab}>
                <TabPane tabId="1">
                    <Form className='mt-5'>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label className="settings-label" for="apiToken">Seu Token</Label>
                                    <Input
                                        id="apiToken"
                                        name="apiToken"
                                        placeholder="Seu Token de API"
                                        type="text"
                                        value={settings.apiToken}
                                        // onChange={handleApiTokenChange}
                                        disabled
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={5} className='d-flex align-items-center '>
                                <Button
                                    color="info d-flex align-items-center justify-content-center mt-3 button-connect"
                                    onClick={PopUpTrelloAuthorize}
                                >
                                    <BsTrello />
                                    Conectar Trello
                                </Button>
                            </Col>
                            <Col lg={6} md={6} style={{display: showAllTabs != true ? "none" : "block"}}>
                                <FormGroup>
                                    <Label className="settings-label" for="trello-board">
                                        Quadro do Trello
                                    </Label>
                                    <Input
                                        id="trello-board"
                                        name="select"
                                        type="select"
                                        onChange={(e) => handleDashboardBoardChange(e)}
                                        value={settings.boardId}
                                    >
                                        <option>
                                            Selecione
                                        </option>
                                        {boards?.map((element, index) => {
                                            return (
                                                <option key={index} value={element.Id}>
                                                    {element.Name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                            <Row>
                                <Col lg={6} md={6} style={{display: showAllTabs != true ? "none" : "block"}}>
                                    <FormGroup>
                                        <Label className="settings-label" for="trello-board">
                                            Seu Email
                                        </Label>
                                        <Input
                                            id="apiToken"
                                            name="apiToken"
                                            placeholder="Seu e-mail"
                                            type="text"
                                            value={settings.email}
                                            onChange={(e) => setSettings({...settings, email: e.target.value})}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                    </Form>
                </TabPane>
                <TabPane tabId="2">
                    <Form className='mt-5 d-flex flex-wrap'>
                        <Row>
                            <Col sm={4} md={3} lg={4}>
                                <FormGroup>
                                    <Label className="settings-label" for="backlog-badge">
                                        Backlog
                                    </Label>
                                    <Input
                                        id="backlog-badge"
                                        name="select"
                                        type="select"
                                        value={settings.kanban.backlog}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSettings((prevSettings) => ({
                                                ...prevSettings,
                                                kanban: {
                                                    ...prevSettings.kanban,
                                                    backlog: selectedValue,
                                                },
                                            }));
                                        }}
                                    >
                                        <option>
                                            {boardLists == null ? "Selecione o Quadro ( Kanban )" : "Selecione"}
                                        </option>
                                        {boardLists?.map((element, index) => {
                                            return (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm={4} md={3} lg={4}>
                                <FormGroup>
                                    <Label className="settings-label" for="todo-badge">
                                        To-Do
                                    </Label>
                                    <Input
                                        id="todo-badge"
                                        name="select"
                                        type="select"
                                        value={settings.kanban.todo}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSettings((prevSettings) => ({
                                                ...prevSettings,
                                                kanban: {
                                                    ...prevSettings.kanban,
                                                    todo: selectedValue,
                                                },
                                            }));
                                        }}
                                    >
                                        <option>
                                            {boardLists == null ? "Selecione o Quadro ( Kanban )" : "Selecione"}
                                        </option>
                                        {boardLists?.map((element, index) => {
                                            return (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm={4} md={3} lg={4}>
                                <FormGroup>
                                    <Label className="settings-label" for="doing-badge">
                                        Doing
                                    </Label>
                                    <Input
                                        id="doing-badge"
                                        name="select"
                                        type="select"
                                        value={settings.kanban.doing}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSettings((prevSettings) => ({
                                                ...prevSettings,
                                                kanban: {
                                                    ...prevSettings.kanban,
                                                    doing: selectedValue,
                                                },
                                            }));
                                        }}
                                    >
                                        <option>
                                            {boardLists == null ? "Selecione o Quadro ( Kanban )" : "Selecione"}
                                        </option>
                                        {boardLists?.map((element, index) => {
                                            return (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm={4} md={3} lg={4}>
                                <FormGroup>
                                    <Label className="settings-label" for="testing-badge">
                                        Testing
                                    </Label>
                                    <Input
                                        id="testing-badge"
                                        name="select"
                                        type="select"
                                        value={settings.kanban.testing}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSettings((prevSettings) => ({
                                                ...prevSettings,
                                                kanban: {
                                                    ...prevSettings.kanban,
                                                    testing: selectedValue,
                                                },
                                            }));
                                        }}
                                    >
                                        <option>
                                            {boardLists == null ? "Selecione o Quadro ( Kanban )" : "Selecione"}
                                        </option>
                                        {boardLists?.map((element, index) => {
                                            return (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm={4} md={3} lg={4}>
                                <FormGroup>
                                    <Label className="settings-label" for="errorfix-badge">
                                        Error Fix
                                    </Label>
                                    <Input
                                        id="errorfix-badge"
                                        name="select"
                                        type="select"
                                        value={settings.kanban.errorFix}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSettings((prevSettings) => ({
                                                ...prevSettings,
                                                kanban: {
                                                    ...prevSettings.kanban,
                                                    errorFix: selectedValue,
                                                },
                                            }));
                                        }}
                                    >
                                        <option>
                                            {boardLists == null ? "Selecione o Quadro ( Kanban )" : "Selecione"}
                                        </option>
                                        {boardLists?.map((element, index) => {
                                            return (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm={4} md={3} lg={4}>
                                <FormGroup>
                                    <Label className="settings-label" for="done-badge">
                                        Done
                                    </Label>
                                    <Input
                                        id="done-badge"
                                        name="select"
                                        type="select"
                                        value={settings.kanban.done}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSettings((prevSettings) => ({
                                                ...prevSettings,
                                                kanban: {
                                                    ...prevSettings.kanban,
                                                    done: selectedValue,
                                                },
                                            }));
                                        }}
                                    >
                                        <option>
                                            {boardLists == null ? "Selecione o Quadro ( Kanban )" : "Selecione"}
                                        </option>
                                        {boardLists?.map((element, index) => {
                                            return (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm={4} md={3} lg={4}>
                                <FormGroup>
                                    <Label className="settings-label" for="reproved-badge">
                                        Reproved
                                    </Label>
                                    <Input
                                        id="reproved-badge"
                                        name="select"
                                        type="select"
                                        value={settings.kanban.reproved}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSettings((prevSettings) => ({
                                                ...prevSettings,
                                                kanban: {
                                                    ...prevSettings.kanban,
                                                    reproved: selectedValue,
                                                },
                                            }));
                                        }}
                                    >
                                        <option>
                                            {boardLists == null ? "Selecione o Quadro ( Kanban )" : "Selecione"}
                                        </option>
                                        {boardLists?.map((element, index) => {
                                            return (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </TabPane>
                <TabPane tabId="3">
                    <Form className='mt-5 d-flex flex-wrap'>
                        <Row>
                            <Col sm={6} md={3} lg={4}>
                                <FormGroup>
                                    <Label className="settings-label" for="easy-badge">
                                        Fácil
                                    </Label>
                                    <Input
                                        id="easy-badge"
                                        name="select"
                                        type="select"
                                        value={settings.complexity.easy}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSettings((prevSettings) => ({
                                                ...prevSettings,
                                                complexity: {
                                                    ...prevSettings.complexity,
                                                    easy: selectedValue,
                                                },
                                            }));
                                        }}
                                    >
                                        <option>
                                            {boardBadges == null ? "Selecione o Quadro ( Kanban )" : "Selecione"}
                                        </option>
                                        {boardBadges?.map((element, index) => {
                                            return (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm={6} md={3} lg={4}>
                                <FormGroup>
                                    <Label className="settings-label" for="mid-badge">
                                        To-Do
                                    </Label>
                                    <Input
                                        id="mid-badge"
                                        name="select"
                                        type="select"
                                        value={settings.complexity.midLevel}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSettings((prevSettings) => ({
                                                ...prevSettings,
                                                complexity: {
                                                    ...prevSettings.complexity,
                                                    midLevel: selectedValue,
                                                },
                                            }));
                                        }}
                                    >
                                        <option>
                                            {boardBadges == null ? "Selecione o Quadro ( Kanban )" : "Selecione"}
                                        </option>
                                        {boardBadges?.map((element, index) => {
                                            return (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm={6} md={3} lg={4}>
                                <FormGroup>
                                    <Label className="settings-label" for="complex-badge">
                                        Doing
                                    </Label>
                                    <Input
                                        id="complex-badge"
                                        name="select"
                                        type="select"
                                        value={settings.complexity.complex}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSettings((prevSettings) => ({
                                                ...prevSettings,
                                                complexity: {
                                                    ...prevSettings.complexity,
                                                    complex: selectedValue,
                                                },
                                            }));
                                        }}
                                    >
                                        <option>
                                            {boardBadges == null ? "Selecione o Quadro ( Kanban )" : "Selecione"}
                                        </option>
                                        {boardBadges?.map((element, index) => {
                                            return (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm={6} md={3} lg={4}>
                                <FormGroup>
                                    <Label className="settings-label" for="very-complex-badge">
                                        Testing
                                    </Label>
                                    <Input
                                        id="very-complex-badge"
                                        name="select"
                                        type="select"
                                        value={settings.complexity.veryComplex}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSettings((prevSettings) => ({
                                                ...prevSettings,
                                                complexity: {
                                                    ...prevSettings.complexity,
                                                    veryComplex: selectedValue,
                                                },
                                            }));
                                        }}
                                    >
                                        <option>
                                            {boardBadges == null ? "Selecione o Quadro ( Kanban )" : "Selecione"}
                                        </option>
                                        {boardBadges?.map((element, index) => {
                                            return (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </TabPane>
            </TabContent>
            <Tooltip id="info-tooltip" />
        </div>
    );
}
